import { baseApiUrl, EVENTS_ENABLED, REBOOK_ENABLED } from '../../config/env';
import AsyncStoreService from '../async-store.service';
import PassengerType from '../../constants/PassengerTypes';
import { setSeatIsAvailable } from '../../utils/seat.utils';
import { getAirportCode, stripAirportCode } from '../../utils/location.utils';
import { isBXservice } from '../../utils/search.utils';
import { AAServiceTypes } from '../../constants/Enums';
import { GetPlatformId } from '../../utils/common.utils';
import { Platform } from 'react-native';
import { initCarTimesForToday } from '../../utils/search.utils';
export const tripSearchApi = async (
  acccessToken,
  searchInput,
  rebookPassengers,
  getCompanyCulture
) => {
  const searchRequest = await buildTripSearchRequest(
    searchInput,
    rebookPassengers,
    getCompanyCulture
  );
  const params = encodeURIComponent(JSON.stringify(searchRequest));
  const res = await fetch(`${baseApiUrl}/trip/search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${acccessToken}`,
    },
    body: `param=${params}`,
  });
  const resultJson = await res.json();
  if (!res.ok) {
    throw new Error(resultJson.Message);
  }
  if (resultJson.TravelRequestId === 0) {
    throw new Error('TravelRequestId is 0');
  }

  return resultJson;
};

const buildTripSearchRequest = async (searchInputParams, rebookPassengers, getCompanyCulture) => {
  const { searchCriteria, ...searchInput } = searchInputParams;

  // mapping base properties that will be needed across both multicity and non multicity
  const mappedCriteria = searchCriteria.map((mModel) => ({
    GroupName: '',
    DepartureDateTime: mModel.fromDate,
    ArrivalDateTime: mModel.toDate,
    OriginLocationCode: mModel.fromCity,
    DestinationLocationCode: mModel.toCity,
    HasAir: searchInput.hasAir,
    HasHotel: searchInput.hasHotel,
    HasCar: searchInput.hasCar,
    HasRail: searchInput.hasRail,
    AirRequestType: +searchInput.airRequestType,
    AirClassType: searchInput.airClassType,
    OriginRegionId: mModel.departRegionId,
    OriginParentId: mModel.departParentKey,
    DestinationRegionId: mModel.arrivalRegionId,
    DestinationParentId: mModel.arrivalParentKey,
    CarPickUpTime:
      mModel.carPickUpTime || initCarTimesForToday(mModel?.fromDate, searchInput.hasAir).pickUpTime,
    CarDropOffTime:
      mModel.carDropOffTime ||
      initCarTimesForToday(mModel?.fromDate, searchInput.hasAir).dropOffTime,
    HotelCategory: mModel.category || '',
    HotelCategoryKey: mModel.categoryKey || '',
    AutoCompleteCategory: mModel.category || 'Airports',
    AutoCompleteCategoryKey: mModel.categoryKey || '', // never referenced in api currently
    NoofCar: searchInput.hasCar ? searchInput.noofCar : undefined,
    NoofRooms: searchInput.hasHotel ? searchInput.noofRooms : undefined,
    IsDifferentDropoff: mModel.isDifferentDropoff || false,
    IsGeoFromSearch: searchInput.IsGeoFromSearch,
    IsGeoToSearch: searchInput.IsGeoToSearch,
    GoogleGeoToCity:
      mModel.isDifferentDropoff && searchInput.IsGeoToSearch ? searchInput.GoogleGeoToCity : {},
    IsReact: true, // to bypass aa ionic flow
    Platform: GetPlatformId(Platform),
    CountryCode:
      getCompanyCulture && getCompanyCulture.CountryCode ? getCompanyCulture.CountryCode : 'US',
    CurrencyCulture:
      getCompanyCulture && getCompanyCulture.CurrencyCode ? getCompanyCulture.CurrencyCode : 'USD',
  }));

  // spread the first criterias props into the top level request, and then use the rest for multi-city if needed
  const searchRequest = { ...mappedCriteria[0] };

  if (searchRequest.AirRequestType === 3) {
    searchRequest.HasMultiCity = true;
    // for air multicity, the last search criteria should not have hotel or car
    if (searchRequest.HasAir) {
      const lastSearchCriteria = mappedCriteria[mappedCriteria.length - 1];
      lastSearchCriteria.HasHotel = false;
      lastSearchCriteria.HasCar = false;
    }

    if (searchRequest.HasAir && (searchRequest.HasHotel == true || searchRequest.HasCar == true)) {
      for (let i = 0; i < mappedCriteria.length; i++) {
        if (typeof mappedCriteria[i + 1] !== 'undefined') {
          mappedCriteria[i].ArrivalDateTime = mappedCriteria[i + 1].DepartureDateTime;
        }
      }
    }

    for (let i = 0; i < mappedCriteria.length; i++) {
      if (
        searchRequest.HasHotel &&
        searchRequest.HasAir == false &&
        searchRequest.HasCar == false
      ) {
        mappedCriteria[i].OriginLocationCode = getAirportCode(searchCriteria[i].arrivalAirport);
        mappedCriteria[i].DestinationLocationCode = getAirportCode(
          searchCriteria[i].arrivalAirport
        );
        mappedCriteria[i].OriginRegionId = searchCriteria[i].arrivalRegionId;
        mappedCriteria[i].OriginParentId = searchCriteria[i].arrivalparentkey;
      }

      if (searchRequest.HasCar && searchRequest.HasCar == false && searchRequest.HasAir == false) {
        mappedCriteria[i].OriginLocationCode = getAirportCode(searchCriteria[i].arrivalAirport);

        mappedCriteria[i].OriginRegionId = searchCriteria[i].arrivalRegionId;
        mappedCriteria[i].OriginParentId = searchCriteria[i].arrivalparentkey;
        mappedCriteria[i].DestinationRegionId = searchCriteria[i].departRegionId;
        mappedCriteria[i].DestinationParentId = searchCriteria[i].departparentkey;

        if (searchCriteria[i].tocity === '') {
          mappedCriteria[i].DestinationLocationCode = searchCriteria[i].fromcity;
        }

        if (typeof searchCriteria[i].DestinationAirport !== 'undefined') {
          mappedCriteria[i].DestinationLocationCode = getAirportCode(
            searchCriteria[i].DestinationAirport
          );
        }

        mappedCriteria[i].OriginRegionId = searchCriteria[i].departRegionId;
        mappedCriteria[i].OriginParentId = searchCriteria[i].departparentkey;
        mappedCriteria[i].DestinationRegionId = searchCriteria[i].arrivalRegionId;
        mappedCriteria[i].DestinationParentId = searchCriteria[i].arrivalparentkey;
      }

      if (searchRequest.HasHotel && searchRequest.HasCar && searchRequest.HasAir == false) {
        mappedCriteria[i].OriginLocationCode = getAirportCode(searchCriteria[i].arrivalAirport);

        mappedCriteria[i].OriginRegionId = searchCriteria[i].arrivalRegionId;
        mappedCriteria[i].OriginParentId = searchCriteria[i].arrivalparentkey;
        mappedCriteria[i].DestinationRegionId = searchCriteria[i].departRegionId;
        mappedCriteria[i].DestinationParentId = searchCriteria[i].departparentkey;

        if (typeof searchCriteria[i].DestinationAirport !== 'undefined') {
          mappedCriteria[i].DestinationLocationCode = getAirportCode(
            searchCriteria[i].DestinationAirport
          );
        }

        if (searchCriteria[i].tocity === '') {
          mappedCriteria[i].DestinationLocationCode = searchCriteria[i].fromcity;
        }
      }
    }

    searchRequest.MultiCity = mappedCriteria;
  } else {
    searchRequest.HasMultiCity = false;
  }
  //map the rest of the toplevel properties that dont need to be included on the inner multicity requests
  searchRequest.IsShuttleService = false;
  searchRequest.IsGeoAutocomplete = searchInput.IsGeoAutocomplete;
  searchRequest.GooglePlace = searchInput.GooglePlace;
  searchRequest.isGeoSearch = searchInput.isGeoSearch;
  searchRequest.ServiceType = searchInput.ServiceType;

  __DEV__ && console.info(searchRequest);
  searchRequest.PassengerTypeQuantity = [];
  if (REBOOK_ENABLED) {
    searchRequest.IsRebook = true;
    searchRequest.RebookString = JSON.stringify(rebookPassengers);
    let adultCount = 0;
    let seniorsCount = 0;
    let childrenCount = 0;
    let infantCount = 0;
    let infantWithSeatCount = 0;
    for (let i = 0; i < rebookPassengers.length; i++) {
      if (rebookPassengers[0].PassengerType === PassengerType.ADULT) {
        adultCount = adultCount + 1;
      } else if (rebookPassengers[0].PassengerType === PassengerType.SENIOR) {
        seniorsCount = seniorsCount + 1;
      } else if (rebookPassengers[0].PassengerType === PassengerType.CHILD) {
        childrenCount = childrenCount + 1;
      } else if (rebookPassengers[0].PassengerType === PassengerType.INFANT) {
        infantCount = infantCount + 1;
      } else if (rebookPassengers[0].PassengerType === PassengerType.INFANTWITHSEAT) {
        infantWithSeatCount = infantWithSeatCount + 1;
      }
    }
    if (adultCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.ADULT;
      pQuantity.Quantity = adultCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }

    if (seniorsCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.SENIOR;
      pQuantity.Quantity = seniorsCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
    if (childrenCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.CHILD;
      pQuantity.Quantity = childrenCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
    if (infantCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.INFANT;
      pQuantity.Quantity = infantCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
    if (infantWithSeatCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.INFANTWITHSEAT;
      pQuantity.Quantity = infantWithSeatCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
  } else {
    if (searchInput.adultCount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.ADULT;
      pQuantity.Quantity = searchInput.adultCount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
    if (searchInput.seniorcount > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.SENIOR;
      pQuantity.Quantity = searchInput.seniorcount;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
    searchInput.infants.forEach((infant) => {
      if (infant.age < 2) {
        const pQuantity = {};
        pQuantity.PassengerType = infant.inSeat
          ? PassengerType.INFANTWITHSEAT
          : PassengerType.INFANT;
        pQuantity.Quantity = 1;
        pQuantity.Age = infant.age;
        searchRequest.PassengerTypeQuantity.push(pQuantity);
      }
    });
  }
  if (searchInput.infants && searchInput.infants != null && searchInput.infants != undefined) {
    const noOfChildren = searchInput.infants.filter((item) => item.age > 1).length;
    if (noOfChildren > 0) {
      const pQuantity = {};
      pQuantity.PassengerType = PassengerType.CHILD;
      pQuantity.Quantity = noOfChildren;
      pQuantity.Age = '';
      searchRequest.PassengerTypeQuantity.push(pQuantity);
    }
  }
  //AA Block
  searchRequest.IsShuttleService = false;
  switch (searchInput.serviceType) {
    case AAServiceTypes.BUSINESS_EXTRA.text:
      searchRequest.ServiceType = AAServiceTypes.BUSINESS_EXTRA.keyword;
      break;
    case AAServiceTypes.CORPORATE_TRAVEL.text:
      searchRequest.ServiceType = AAServiceTypes.CORPORATE_TRAVEL.keyword;
      break;
    case AAServiceTypes.LEISURE.text:
      searchRequest.ServiceType = AAServiceTypes.LEISURE.keyword;
      break;
  }

  return searchRequest;
};

export const redeemCalendarApi = async (accessToken, requestKey, authNumber) => {
  const res = await fetch(
    `${baseApiUrl}/air/RedeemCalender?authNumber=${authNumber}&requestKey=${requestKey}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  if (!res.ok) {
    throw new Error('Error getting redeem calendar');
  }
  return await res.json();
};

export const isSkipCalendarApi = async (accessToken, authNumber, travelRequestId) => {
  const res = await fetch(
    `${baseApiUrl}/air/IsSkipCalendar?authNumber=${authNumber}&requestKey=${travelRequestId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  if (!res.ok) {
    // this is swallowing the http error message, but it's currently hardcoded/swallowed on backend anyways.
    throw new Error('Error doing air search');
  }
  return res.json();
};

export const selectNextPriceAPI = async (
  pickupDate,
  dropoffDate,
  travelRequestId,
  searchInput,
  accessToken,
  getCompanyCulture
) => {
  const searchRequest = await buildTripSearchRequest(searchInput, null, getCompanyCulture);
  const stringSearchRequest = encodeURIComponent(JSON.stringify(searchRequest));
  const res = await fetch(`${baseApiUrl}/air/SelectNextPrice`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
    body:
      `pickupDate=${pickupDate}` +
      `&dropoffDate=${dropoffDate}` +
      `&travelRequestId=${travelRequestId}` +
      `&stringSearchRequest=${stringSearchRequest}`,
  });
  if (!res.ok) {
    // this is swallowing the http error message, but it's currently hardcoded/swallowed on backend anyways.
    throw new Error('Error doing select next price');
  }
  return res.json();
};

export const searchAirApi = async (
  accessToken,
  travelRequestId,
  componentRequestId,
  routeParams,
  serviceType,
  airResponseKeyLeg1,
  selectedAirline,
  changeResTripInfo,
  selectedMultibrandKey,
  selectedEvent,
  lowestFareForLeg1
) => {
  const { legNumber, selectedAwardCode } = routeParams;
  const allLegs = changeResTripInfo?.AirResponseDetails?.AirLegs.map((airLeg) => {
    return ':' + airLeg.LegNumber;
  });
  const queryParam = {
    RequestKey: travelRequestId,
    ComponentRequestKey: componentRequestId,
    IsStatic: true,
    IsShuttleService: false,
    LegNumber: legNumber,
    TripId: typeof changeResTripInfo !== 'undefined' ? changeResTripInfo.TripId : 0,
    SelectedAirline: selectedAirline,
    OldTicketNumber: changeResTripInfo?.TicketInfos[0],
    OldSelectedLegs: allLegs ? allLegs.join('') : null,
    SelectedAward: selectedAwardCode,
    IsBXlist: isBXservice(serviceType),
    LowestPrice: lowestFareForLeg1,
  };

  if (EVENTS_ENABLED) {
    //code key required to match flight time & event time
    const event = {
      EventId: selectedEvent.CodeKey,
      MeetingCode: selectedEvent.Code,
    };
    queryParam['Event'] = event;
  }
  if (airResponseKeyLeg1) {
    queryParam.AirResponseKeyLeg1 = airResponseKeyLeg1;
  }
  if (selectedMultibrandKey) {
    queryParam.MultiCabinKeyLeg1 = selectedMultibrandKey;
  }
  const queryParamStr = encodeURIComponent(JSON.stringify(queryParam));

  const res = await fetch(`${baseApiUrl}/air/list_new?listRQ=${queryParamStr}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    // this is swallowing the http error message, but it's currently hardcoded/swallowed on backend anyways.
    throw new Error('Error doing air search');
  }
  return res.json();
};
export const searchAirCloudApi = async (
  accessToken,
  travelRequestId,
  componentRequestId,
  routeParams,
  serviceType,
  airResponseKeyLeg1,
  selectedAirline,
  changeResTripInfo,
  selectedMultibrandKey,
  selectedEvent,
  lowestFareForLeg1,
  airReqComponentRedisKey
) => {
  const { legNumber, selectedAwardCode } = routeParams;
  const allLegs = changeResTripInfo?.AirResponseDetails?.AirLegs.map((airLeg) => {
    return ':' + airLeg.LegNumber;
  });
  const queryParam = {
    RequestKey: travelRequestId,
    ComponentRequestKey: componentRequestId,
    IsStatic: true,
    IsShuttleService: false,
    LegNumber: legNumber,
    TripId: typeof changeResTripInfo !== 'undefined' ? changeResTripInfo.TripId : 0,
    SelectedAirline: selectedAirline,
    OldTicketNumber: changeResTripInfo?.TicketInfos[0],
    OldSelectedLegs: allLegs ? allLegs.join('') : null,
    SelectedAward: selectedAwardCode,
    IsBXlist: isBXservice(serviceType),
    LowestPrice: lowestFareForLeg1,
    RedisCacheKey: airReqComponentRedisKey,
  };

  if (EVENTS_ENABLED) {
    //code key required to match flight time & event time
    const event = {
      EventId: selectedEvent.CodeKey,
      MeetingCode: selectedEvent.Code,
    };
    queryParam['Event'] = event;
  }
  if (airResponseKeyLeg1) {
    //parent id
    queryParam.AirResponseKeyLeg1 = airResponseKeyLeg1;
  }
  if (selectedMultibrandKey) {
    //fare id:
    queryParam.MultiCabinKeyLeg1 = selectedMultibrandKey;
  }
  const queryParamStr = encodeURIComponent(JSON.stringify(queryParam));

  const res = await fetch(`${baseApiUrl}/air/list_newV2?listRQ=${queryParamStr}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    // this is swallowing the http error message, but it's currently hardcoded/swallowed on backend anyways.
    throw new Error('Error doing air search');
  }
  return res.json();
};

export const searchBXAirApi = async (accessToken, travelRequestId, routeParams) => {
  const { selectedDates, legNumber, authNumber, selectedAwardCode } = routeParams;
  const { departDate, arrivalDate } = selectedDates;
  const { awardCode, points } = selectedAwardCode;
  const queryParam = {
    requestKey: travelRequestId,
    departDate,
    arrivalDate,
    authNumber,
    awarCode: awardCode,
    points: parseInt(points),
    legNumber,
    selectedAwardName: awardCode,
  };
  const queryParamStr = encodeURIComponent(JSON.stringify(queryParam));

  const res = await fetch(`${baseApiUrl}/air/ListResponses?listRQ=${queryParamStr}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    // this is swallowing the http error message, but it's currently hardcoded/swallowed on backend anyways.
    throw new Error('Error doing air search');
  }
  return res.json();
};

export const getResponseKeyFromMultiBrandKey = async (accessToken, multiBrandKey) => {
  try {
    const res = await fetch(
      `${baseApiUrl}/air/GetAirResponseKeyFromMultiBrandKey?multiBrandResponseKey=${multiBrandKey}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (!res.ok) {
      return '';
    }
    return res.json();
  } catch (error) {
    return '';
  }
};

export const searchHotelApi = async (accessToken, travelRequestId, componentRequestId) => {
  const queryParam = {
    RequestKey: travelRequestId,
    ComponentRequestKey: componentRequestId,
    IsStatic: false,
    IsShuttleService: false,
    IsAirportSearch: true,
    IsGeoSearch: false,
    IsCitySearch: false,
  };
  const queryParamStr = encodeURIComponent(JSON.stringify(queryParam));
  const res = await fetch(`${baseApiUrl}/hotel/list?listRQ=${queryParamStr}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('Error doing hotel list search');
  }
  return res.json();
};

export const getHotelDetailApi = async (accessToken, hotelDetailRequest) => {
  const queryParamStr = encodeURIComponent(JSON.stringify(hotelDetailRequest));
  const res = await fetch(`${baseApiUrl}/hotel/view?HotelDetailRQ=${queryParamStr}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('Error doing hotel detail search');
  }
  return res.json();
};

export const searchCarApi = async (accessToken, travelRequestId, componentRequestId) => {
  const queryParam = `{"RequestKey":${travelRequestId},"ComponentRequestKey":${componentRequestId},"IsStatic":false,"IsShuttleService":false,"LegNumber":1}`;
  const res = await fetch(`${baseApiUrl}/car/list?listRQ=${queryParam}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('Error doing car search');
  }
  return res.json();
};

export const handleFiftyMileSearchClick = async (
  accessToken,
  travelRequestId,
  componentRequestId,
  searchInput,
  rebookPassengers,
  getCompanyCulture
) => {
  const searchRequest = await buildTripSearchRequest(
    searchInput,
    rebookPassengers,
    getCompanyCulture
  );
  const params = JSON.stringify(searchRequest);
  const radius = '50';

  const queryParam = `{"ComponentRequestId":${componentRequestId},"TravelRequestId":${travelRequestId},"Radius":${radius},"SearchRequest":${params}}`;

  try {
    const response = await fetch(
      `${baseApiUrl}/car/CarSearchUnderDistance?carSearchRequest=${queryParam}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  } catch (error) {
    console.log(error);
  }
};

export const cartViewApi = async (accessToken, tripRequest, { selectedCar, selectedAir }) => {
  const tripRequestStr = JSON.stringify(tripRequest);

  const body = {
    param: tripRequestStr,
  };

  if (selectedCar && selectedCar.length > 0) {
    body.selectedCar = JSON.stringify(selectedCar);
  }

  if (selectedAir && Object.keys(selectedAir)?.length) {
    body.selectedAir = JSON.stringify(selectedAir);
  }

  const res = await fetch(`${baseApiUrl}/cart/view`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
    body: new URLSearchParams(body).toString(),
  });
  if (!res.ok) {
    throw new Error('error doing trip summary');
  }
  return res.json();
};

export const getTravelCartApi = async (
  accessToken,
  searchInput,
  travelRequestId,
  policyBreachedObj,
  Passengers,
  Supplier
) => {
  const { IsAirPolicyBreached, IsHotelPolicyBreached, IsCarPolicyBreached } = policyBreachedObj;
  const param = {
    TravelRequestId: travelRequestId,
    IsAirPolicyBreached,
    IsHotelPolicyBreached,
    IsCarPolicyBreached,
    HotelSupplier: '',
    TripKey: 0,
    IsRedeem: false,
    SelectedAwardCode: '',
    IsAir: searchInput.hasAir,
    IsHotel: searchInput.hasHotel,
    IsCar: searchInput.hasCar,
    IsRail: searchInput.hasRail,
    Passengers,
    Supplier,
  };
  const paramJsonStr = JSON.stringify(param);
  const res = await fetch(`${baseApiUrl}/cart/GetTravelCart`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
    body: 'param=' + encodeURIComponent(paramJsonStr),
  });
  if (!res.ok) {
    throw new Error('error getting travel cart');
  }

  return res.json();
};

export const getSeatMapApi = async (accessToken, seatMapRequest) => {
  const res = await fetch(`${baseApiUrl}/air/Seatmap?seatMapRQ=${JSON.stringify(seatMapRequest)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    // sometimes seatmap request returns a 200 with ErrorMessage inside response, othertimes it returns 417 with different generic failure message.
    // standardizing to the ErrorMessage in the 417 case since its we are not providing a different UX to user in either case.
    return { ErrorMessage: 'Seat map not available.' };
  }
  const resultJson = await res.json();
  const classesOfService = resultJson && resultJson.ClassesOfService && resultJson.ClassesOfService;
  if (classesOfService) {
    classesOfService.forEach((classService) => {
      classService.Rows.forEach((row) => {
        let previousSeatWasAisle = false;
        const newSeats = [];
        row.Seats.forEach((seat) => {
          seat.SeatNumber = row.Number + seat.Name;
          seat.Price = seat.Price == null || seat.Price == '' ? 0 : seat.Price;
          seat.DispPrice = Math.round(seat.Price);
          seat.IsAvailable = setSeatIsAvailable(seat);
          seat.row = row.Number;
          if (seat.Description && seat.Description.toLowerCase() === 'main cabin extra') {
            seat.maincabinextra = true;
          }
          if (seat.IsAvailable == false) {
            seat.maincabinextra = false;
          }
          if (seat.Description && seat.Description.toLowerCase() === 'preferred seats') {
            seat.preferredseat = true;
          }
          if (seat.IsAvailable == false) {
            seat.preferredseat = false;
          }

          if (seat.SeatPosition === 'Aisle') {
            if (!previousSeatWasAisle) {
              previousSeatWasAisle = true;
            } else {
              newSeats.push({ isAisleFiller: true });
              previousSeatWasAisle = false;
            }
          }
          newSeats.push(seat);
        });
        row.Seats = newSeats;
      });
    });
  }
  return resultJson;
};

export const getLocationList = async (searchParam, componentType) => {
  const code = `${searchParam}${componentType}`.toLowerCase();
  const url = `${baseApiUrl}/location/list?code=${code}`;
  try {
    const accessToken = await AsyncStoreService.getTokenData();
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    let json = await res.json();
    json = json ? JSON.parse(JSON.parse(json)) : json;
    return json;
  } catch (error) {
    console.error(error);
  }
};

export const getLocationDetail = async (selectedText, category, componentType, regionId) => {
  const SelectedText =
    category === 'A' ? getAirportCode(selectedText) : encodeURIComponent(selectedText);
  const request = {
    SelectedText,
    Category: category,
    ComponentType: componentType,
    IsParentKey: 0,
    RegionId: regionId,
  };
  const url = `${baseApiUrl}/location/details?locationRQ=${JSON.stringify(request)}`;
  try {
    const accessToken = await AsyncStoreService.getTokenData();
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    let json = await res.json();
    json = json && JSON.parse(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};

export const getCarAutocompleteList = async (search) => {
  const accessToken = await AsyncStoreService.getTokenData();
  const url = `${baseApiUrl}/location/GetCarAutoCompleteData?strSearch=${search?.toLowerCase()}`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const json = await res.json();
    return json;
  } catch (error) {
    console.error(error);
  }
};

export const getNearestAirportFromCoords = async (locationRequest) => {
  const accessToken = await AsyncStoreService.getTokenData();
  try {
    const res = await fetch(
      `${baseApiUrl}/location/track?LocationRQ=${JSON.stringify(locationRequest)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return res.json();
  } catch (error) {
    console.error(error);
    // puposely supressing the error since it's non critical
    return {};
  }
};

export const getNextRailResultsApi = async (accessToken, params, railTravelComponent) => {
  const res = await fetch(
    `${baseApiUrl}/rail/SelectRail?railRQ=${params}&railTravelComponent=${railTravelComponent}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  if (!res.ok) {
    throw new Error('error doing getNextRailResultsApi');
  }
  return res.json();
};

export const googleAutocompleteApi = async (address) => {
  const accessToken = await AsyncStoreService.getTokenData();
  const apiURL = `${baseApiUrl}/search/googleAutocomplete?address=` + address;
  const result = await fetch(apiURL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const content = await result.json();
  return JSON.parse(content);
};

export const getAddressFromCoords = async (coords) => {
  const accessToken = await AsyncStoreService.getTokenData();
  const apiURL = `${baseApiUrl}/search/GetAddressFromCoords?coords=` + coords;
  const result = await fetch(apiURL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const content = await result.json();
  return JSON.parse(content);
};
